<template>
    <div class="expenses">
        <div class="content">
            <div class="wrap">
                <div class="wrap__tree">
                    <!-- <div class="nav-tree">
                      <el-button v-if="companyLayout" :disabled="!companyLayout.permission.addTransactionJournal" @click="openModalCreateJournalEntry(activeState)" class="nav-tree__item_btn" size="mini" type="primary" plain icon="el-icon-plus">Create Journal Entry</el-button>
                    </div> -->

                    <el-row :gutter="20" style="margin-bottom: 10px;">
                      <el-col :span="12" :offset="0">
                        <el-button v-if="companyLayout" :disabled="!companyLayout.permission.addTransactionJournal" @click="openModalCreateJournalEntry(activeState)" class="nav-tree__item_btn" size="mini" type="primary" plain icon="el-icon-plus">Create General Journal Entry</el-button>
                        <el-button @click="importJE" class="nav-tree__item_btn" size="mini" type="primary" plain icon="el-icon-plus">Import</el-button>
                      </el-col>
                      <el-col :span="12" :offset="0" style="text-align: right;">
                        <span v-if="companyLayout.lockAccountingPeriodTo" style="margin-right: 10px;">
                          Reporting period is locked until: {{moment(companyLayout.lockAccountingPeriodTo).format('D MMM YYYY')}}
                        </span>
                        <el-button type="primary" size="mini" @click="openGL">GENERAL LEDGER</el-button>
                        <!-- <el-button type="success" size="mini" @click="openATDashboard">aT Dashboard</el-button>-->
                      </el-col>
                    </el-row>

                    <div style="margin-bottom: 10px;">
                      <el-date-picker
                        popper-class="custom-date-picker"
                        size="mini"
                        v-model="period"
                        style="margin-right: 10px;"
                        prefix-icon="el-icon-date"
                        type="daterange"
                        align="center"
                        format="d MMM yy"
                        value-format="timestamp"
                        range-separator=""
                        start-placeholder="Start date"
                        end-placeholder="End date"
                        @change="setFilter('period')"
                        :picker-options="pickerOptions">
                      </el-date-picker>

                      <el-select v-model="coa" placeholder="COA" clearable filterable size="mini" style="margin-right: 10px;">
                        <el-option v-for="item in coaList"
                          :key="item.id"
                          :label="item.name"
                          :value="item.id"
                          @click.native="setFilter('account', item)">
                        </el-option>
                      </el-select>

                      <el-select :disabled="activeTab == 'journalReport'" v-model="taxCode" placeholder="Tax Code" clearable filterable size="mini" style="margin-right: 10px;">
                        <el-option v-for="item in taxCodeList"
                          :key="item.id"
                          :label="item.name"
                          :value="item.id"
                          @click.native="setFilter('tax', item)">
                        </el-option>
                      </el-select>

                      <el-input
                        disabled
                        v-model="search"
                        style="width: 171px; margin-right: 10px;"
                        placeholder="Search"
                        size="mini"
                        prefix-icon="el-icon-search">
                      </el-input>

                      <ReportAction
                        :period="period"
                        :activeTab="activeTab"
                        :filterBy="filterBy"
                        :filterValue="filterValue" />

                    </div>

                    <el-tabs v-model="activeTab" type="card" @tab-click="handleClickMainTabs">
                        <el-tab-pane v-if="showHide === 2" name="sales" label="Sales">
                          <sales
                              :transactionId="transactionId"
                              ref="sales"
                              @resetTransition="transactionId = null"/>
                        </el-tab-pane>
                        <el-tab-pane v-if="showHide === 2" name="purchase" label="Purchase">
                          <purchase
                              :transactionId="transactionId"
                              ref="purchase"
                              @resetTransition="transactionId = null"/>
                        </el-tab-pane>
                        <el-tab-pane v-if="showHide === 2 || showHide === 1" name="cashReceipts" label="Cash Receipts">
                          <cashReceipts
                              :transactionId="transactionId"
                              ref="cashReceipts"
                              @resetTransition="transactionId = null"/>
                        </el-tab-pane>
                        <el-tab-pane v-if="showHide === 2 || showHide === 1" name="cashDisbursements" label="Cash Disbursements">
                          <cashDisbursements
                              :transactionId="transactionId"
                              ref="cashDisbursements"
                              @resetTransition="transactionId = null"/>
                        </el-tab-pane>
                        <el-tab-pane v-if="showHide === 2 && countryForTaxRepId !== 103" name="salesReturns" label="Sales Returns">
                          <salesReturns
                              :transactionId="transactionId"
                              ref="salesReturns"
                              @resetTransition="transactionId = null"/>
                        </el-tab-pane>
                        <el-tab-pane v-if="showHide === 2 && countryForTaxRepId !== 103" name="purchaseReturns" label="Purchase Returns">
                          <purchaseReturns
                              :transactionId="transactionId"
                              ref="purchaseReturns"
                              @resetTransition="transactionId = null"/>
                        </el-tab-pane>
                        <el-tab-pane v-if="showHide === 2 || showHide === 1" name="general" label="General">
                          <general
                              :transactionId="transactionId"
                              ref="general"
                              @resetTransition="transactionId = null"
                          />
                        </el-tab-pane>
                        <el-tab-pane v-if="payrollJournal" name="payroll" label="Payroll">
                          <!-- TODO: -->
                        </el-tab-pane>
                        <el-tab-pane name="journalReport" label="Journal Report">
                          <journal-report
                              :transactionId="transactionId"
                              @resetTransition="transactionId = null"
                              ref="journalReport"/>
                        </el-tab-pane>
                        <el-tab-pane name="deleted" label="Deleted Entries">
                          <deleted
                              :transactionId="transactionId"
                              ref="deleted"
                              @resetTransition="transactionId = null"
                          />
                        </el-tab-pane>
                        <el-tab-pane name="voidEntries" label="Void Entries">
                          <!-- TODO: -->
                          <void
                              :transactionId="transactionId"
                              ref="void"
                              @resetTransition="transactionId = null"
                          />
                        </el-tab-pane>
                        <el-tab-pane name="auditReport" label="Audit Report">
                          <!-- TODO: -->
                        </el-tab-pane>
                        <el-tab-pane name="templates" label="Templates">
                          <templates
                              :transactionId="transactionId"
                              ref="templates"
                              @resetTransition="transactionId = null"
                          />
                        </el-tab-pane>
                    </el-tabs>
                </div>
            </div>
        </div>


        <!--VENDOR INVOICE INFO MODAL-->
        <vendorRequestInvoiceInfoModal ref="vendorRequestInvoiceInfoModal"/>
        <!--VENDOR INVOICE INFO MODAL-->

        <!--VENDOR INVOICE INFO MODAL-->
        <journalEntryInfoModal ref="journalEntryInfoModal"/>
        <!--VENDOR INVOICE INFO MODAL-->

        <!--Journal Entry modal create-->
        <createJournalEntryModal :selectedRow="selectedRow" :transactionCode="transactionCode" @updateList='getList' ref="createJournalEntryModal"/>
        <!--Journal Entry modal create-->

        <!--VENDOR INVOICE MODAL CREATE-->
        <createVendorInvoiceModal :selectedRow="selectedRow" @setValueProject='setValueProjectAfterSubmitModal' ref="createVendorInvoiceModal"/>
        <!--VENDOR INVOICE MODAL CREATE-->

        <!--VENDOR INVOICE MODAL EDIT-->
        <editVendorInvoiceModal :selectedRow="selectedRow" @setValueProject='setValueProjectAfterSubmitModal' ref="editVendorInvoiceModal"/>
        <!--VENDOR INVOICE MODAL EDIT-->

        <div v-if="viewerType == 1">
            <sweet-modal blocking v-if="viewerType == 1" ref="nestedChild">
                <iframe class="iframe" :src="fileUrl" frameborder="0"></iframe>
            </sweet-modal>
        </div>
        <div v-if="viewerType == 2">
            <div v-show="false" class="images" v-viewer="{movable: true}">
                <img :src="fileUrl" :key="fileUrl" />
            </div>
        </div>
        <div class="mod" v-if="viewerType == 3">
            <div @click="closeMod" class="mod__close">
                <span>x</span>
            </div>
            <Media
                    :kind="'video'"
                    :controls="true"
                    :src="fileUrl"
            >
            </Media>
        </div>
        <div class="mod" v-if="viewerType == 4">
            <div @click="closeMod" class="mod__close">
                <span>x</span>
            </div>
            <Media
                    :kind="'audio'"
                    :controls="true"
                    :src="fileUrl"
            >
            </Media>
        </div>

        <sweet-modal blocking title="Import JE" width="700" ref="importClients" class="modal">

          <!-- <p>Download the tamplate file and follow instruction from first Sheet</p>

          <div style="margin-bottom: 20px;">
            <a :href="downloadURL" download>Download template XLS</a>
          </div> -->

          <form class="importClients">
            <label for="fileImport" class="importClients__label">
              <i class="el-icon-upload"></i> {{$t('modal_uploadFile')}}
            </label>
            <input v-show="false" @change="handleFileImport" ref="fileImport" id="fileImport" name="myFileImport" type="file">
          </form>
        </sweet-modal>
    </div>
</template>

<script>
  import projectExpenseModal from '@/components/Projects/projectExpenseModal.vue'
  import journalEntryInfoModal from '@/components/journalAndGl/journalEntryInfoModal.vue'
  import vendorRequestInvoiceInfoModal from '@/components/vendorInvoices/vendorRequestInvoiceInfoModal.vue'
  import createJournalEntryModal from '@/components/journalAndGl/createJournalEntryModal.vue'
  import createVendorInvoiceModal from '@/components/vendorInvoices/createVendorInvoiceModal.vue'
  import editVendorInvoiceModal from '@/components/vendorInvoices/editVendorInvoiceModal.vue'
  import Sales from '@/components/journalEntries/sales.vue'
  import Purchase from '@/components/journalEntries/purchase.vue'
  import General from '@/components/journalEntries/general.vue'
  import Deleted from '@/components/journalEntries/deleted.vue'
  import Void from '@/components/journalEntries/void.vue'
  import Templates from '@/components/journalEntries/templates.vue'
  import cashReceipts from '@/components/journalEntries/cashReceipt.vue'
  import cashDisbursements from '@/components/journalEntries/cashDisbursement.vue'
  import purchaseReturns from '@/components/journalEntries/purchaseReturn.vue'
  import salesReturns from '@/components/journalEntries/salesReturn.vue'
  import ReportAction from '@/views/accountTHINK/ReportAction.vue'



  let moment = require('moment')
  import axios from 'axios'
  import { SweetModal } from '@totalflow4/tfsweet-modal-vue'
  import Media from '@dongido/vue-viaudio'
  import JournalReport from "../../components/journalEntries/journalReport";
  export default {
    name: 'journal-and-gl',
    components: {
      JournalReport,
      SweetModal,
      projectExpenseModal,
      journalEntryInfoModal,
      vendorRequestInvoiceInfoModal,
      createVendorInvoiceModal,
      createJournalEntryModal,
      editVendorInvoiceModal,
      Media,
      Sales,
      Purchase,
      General,
      Deleted,
      Void,
      Templates,
      cashReceipts,
      cashDisbursements,
      purchaseReturns,
      salesReturns,
      ReportAction
    },
    beforeCreate() {
    },
    beforeMount() {
    },
    computed: {
      companyLayout() {
        return this.$store.getters.getCompanyLayout
      },
    },
    async mounted() {
      await this.showHideTabs()
      this.getDirectory()
      if (this.$route.query.tab) {
        this.activeTab = this.$route.query.tab
      } else {
        this.activeTab = 'sales'
      }
      this.transactionId = this.$route.query.transactionId
      this.handleClickMainTabs({ name: this.activeTab })
    },
    data() {
      return {
        showHide: 2,
        payrollJournal: true,
        countryForTaxRepId: null,
        transactionId: null,
        activeTab: 'sales',
        transactionCode: 'SALES',
        labelName: 'Project',
        activeState: 'projectTaskVendorInvoice',
        projectId: '',
        projects:[],
        selectedRow:{},
        journalEntryList:[],
        vendorInvoiceList:[],
        generalList: [],
        moment:moment,
        companyNameSelect: '',
        slectedRowId: '',
        fileUrl: '',
        type: '',
        viewerType: '',
        allowMyProjectTaskExpenseList:true,
        allowProjectTaskExpenseList:true,
        activeCompanyId: '',
        activeProjectId: '',
        activeTaskId: '',
        activeExpenseId: '',
        description: '',
        isLeader: false,
        createTimestamp: '',

        // filter
        period: [],
        coaList: [],
        coa: null,
        taxCodeList: [],
        taxCode: null,
        search: '',
        filterBy: null,
        filterValue: null,

        pickerOptions: {
          shortcuts: [{
            text: 'This month',
            onClick(picker) {
              const end = moment().endOf('month');
              const start = moment().startOf('month');
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: 'Last month',
            onClick(picker) {
              const end = moment().endOf('month').subtract(1, 'months');
              const start = moment().startOf('month').subtract(1, 'months');
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: 'Last 3 months',
            onClick(picker) {
              const end = moment().endOf('month').subtract(1, 'months');
              const start = moment().startOf('month').subtract(3, 'months');
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: 'This financial quarter',
            onClick(picker) {
              const end = moment().endOf('quarter');
              const start = moment().startOf('quarter');
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: 'Last financial quarter',
            onClick(picker) {
              const end = moment().subtract(1, 'quarter').endOf('quarter');
              const start = moment().subtract(1, 'quarter').startOf('quarter');
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: 'This financial year',
            onClick(picker) {
              const end = moment().endOf('year');
              const start = moment().startOf('year');
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: 'Last financial year',
            onClick(picker) {
              const end = moment().endOf('year').subtract(1, 'year');
              const start = moment().startOf('year').subtract(1, 'year');
              picker.$emit('pick', [start, end]);
            }
          }]
        },
      }
    },
    methods: {
      importJE() {
        this.$refs.importClients.open()
      },
      handleFileImport(e) {
        var formData = new FormData();
        formData.append('file', e.target.files[0]);

        let loader = this.$loading.show();
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
        axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
        axios.post(`/api/v1/journalEntry/import?companyId=${this.$route.query.companyId}`, formData)
          .then(response => {
            this.notification("Success", "File upload", "success")
            this.$refs.fileImport.value = ''
            this.getList()
            this.$refs.importClients.close()
            loader.hide()
          })
          .catch(error => {
            console.log('An error occurred:', error);
            this.$refs.fileImport.value = ''
            loader.hide()
          });
      },
      showHideTabs() {
        return new Promise((resolve, reject) => {
          let loader = this.$loading.show();
          axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
          axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
          axios
              .get(`/api/v1/company-accounting-and-business-info/item?companyId=${this.$route.query.companyId}`)
              .then(response => {
                if (response.data.item) {
                  this.showHide = response.data.item.methodOfAccountingId ? response.data.item.methodOfAccountingId : null
                  this.countryForTaxRepId = response.data.item.countryForTaxRepId
                } else {
                  this.showHide = false
                }
                this.payrollJournal = response.data.item.payrollJournalId === 1 ? true : false
                loader.hide()
                resolve('ok')
              })
              .catch(error => {
                console.log('An error occurred:', error);
                loader.hide()
                reject(error)
              });
        })
      },
      openATDashboard() {
        this.$router.push(`/account-think?companyId=${this.$route.query.companyId}`)
      },
      openGL() {
        this.$router.push(`/general-ledger?companyId=${this.$route.query.companyId}`)
      },
      setFilter(filterBy, value) {
        this.filterBy = filterBy

        switch (filterBy) {
          case 'account':
            this.taxCode = null
            this.period = []
            this.filterValue = {
              accountId: value.id
            }
            this.filterValue = JSON.stringify(this.filterValue)
            break;
          case 'tax':
            this.coa = null
            this.period = []
            this.filterValue = {
              taxTypeId: value.taxTypeId,
              taxId: value.id,
            }
            this.filterValue = JSON.stringify(this.filterValue)
            break;
          case 'period':
            this.taxCode = null
            this.coa = null
            if (this.period) {
              this.filterValue = {
                startDate: moment(this.period[0]).format('YYYY-MM-DD HH:mm:ss.sss'),
                endDate: moment(this.period[1]).format('YYYY-MM-DD HH:mm:ss.sss'),
              }
              this.filterValue = JSON.stringify(this.filterValue)
            } else {
              this.filterBy = null
              this.filterValue = null
            }
        }

        this.$refs[this.activeTab].item(this.filterBy, this.filterValue)
      },
      getDirectory() {
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
        axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
        axios
          .get(`/api/v1/journalEntry/directory?companyId=${this.$route.query.companyId}`)
          .then(response => {
            this.coaList = response.data.accountsList
            this.taxCodeList = response.data.taxList
          })
          .catch(error => {
            console.log('An error occurred:', error);
          });
      },
      getProjects(state){
        let myState = '';
        switch (state){
          case 'projectTaskVendorInvoice':
            this.projects = [{name: 'All Projects', id: 'all'}]
            myState = 'projects';
            break;
          case 'engagementTaskVendorInvoice':
            this.projects = [{name: 'All Engagements', id: 'all'}]
            myState = 'engagements';
            break;
          case 'businessUnitTaskVendorInvoice':
            this.projects = [{name: 'All Business Units', id: 'all'}]
            myState = 'businessUnits';
            break;
        }
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
        axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
        axios
          .post(`/api/v1/${myState}/list?companyId=${this.$route.query.companyId}`)
          .then(response => {
            this.projects =  this.projects.concat(response.data.list)
            this.projectId = this.projects[0].id
            // this.checkStatus(this.projectId)
            this.setValueProjectAfterSubmit(this.projectId, state)
          }).catch(error =>{

        })
      },
      openModalAsk(){
        this.$refs['askBefore'].open()
      },
      refreshVendorInvoiceRequest(){
        this.setValueProjectAfterSubmit(this.projectId, this.activeState)
      },
      setValueProjectAfterSubmit(projectId, state){
        if(projectId === 'all'){
          this.setValueProjectAll(state)
        }else{
          this.setValueProject(projectId, state)
        }
      },
      setValueProjectAfterSubmitModal(projectId){
        if(this.projectId === 'all'){
          this.setValueProjectAll(this.activeState)
        }else{
          this.setValueProject(projectId, this.activeState)
        }
      },
      getList() {
        if(this.activeTab === 'general'){
          this.$refs['general'].openModal()
        } else if (this.activeTab === 'purchase') {
          this.$refs['purchase'].openModal()
        } else if (this.activeTab === 'sales') {
          this.$refs['sales'].openModal()
        } else if (this.activeTab === 'cashReceipts') {
          this.$refs['cashReceipts'].openModal()
        } else if (this.activeTab === 'cashDisbursements') {
          this.$refs['cashDisbursements'].openModal()
        } else if (this.activeTab === 'purchaseReturns') {
          this.$refs['purchaseReturns'].openModal()
        } else if (this.activeTab === 'salesReturns') {
          this.$refs['salesReturns'].openModal()
        } else if (this.activeTab === 'deleted') {
          this.$refs['deleted'].openModal()
        } else if (this.activeTab === 'voidEntries') {
          this.$refs['void'].openModal()
        } else if (this.activeTab === 'templates') {
          this.$refs['templates'].openModal()
        }
      },
      formatPrice(value) {
        let val = (value/1).toFixed(2).replace('.', ',');
        return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")
      },
      setValueProject(projectId, state){

        const urlParts = this.buildUrl(state, false);
        console.log('urlParts', urlParts);
        this.projectId = projectId;
        let loader = this.$loading.show();
        this.$router.push(`/journal-and-gl?companyId=${this.$route.query.companyId}&${urlParts.stateProjectId}=${projectId}`);
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
        axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
        axios
          .get(`/api/v1/${urlParts.myState}/list?companyId=${this.$route.query.companyId}`)
          .then(response => {
            switch(this.activeTab){
              case 'journalEntry':
                this.journalEntryList = response.data.list;
                break;
              case 'vendorInvoice':
                this.vendorInvoiceList = response.data.list;
                break;
            }
          }).catch(error =>{
          loader.hide()
        })
      },
      setValueProjectAll(state){
        const urlParts = this.buildUrl(state, false);
        console.log('urlParts', urlParts);
        // this.projectId = projectId
        let loader = this.$loading.show();
        this.$router.push(`/journal-and-gl?companyId=${this.$route.query.companyId}`);
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
        axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
        axios
          .get(`/api/v1/${urlParts.myState}/list?companyId=${this.$route.query.companyId}&type=${urlParts.type}`)
          .then(response => {
            switch(this.activeTab){
              case 'journalEntry':
                this.journalEntryList = response.data.list;
                break;
              case 'vendorInvoice':
                this.vendorInvoiceList = response.data.list;
                break;
            }
            loader.hide()
          }).catch(error =>{
          loader.hide()
        })
      },
      tableRowClassName({row, rowIndex}) {
        return 'table-rows'
      },
      handleEdit(index, row, state){
        console.log('row', row);
        const urlParts = this.buildUrl(state, row);
        this.$refs['editVendorInvoiceModal'].openModalEdit(row.companyId, row.projectId || row.engagementId || row.businessUnitId, row.projectTaskId || row.engagementTaskId || row.businessUnitTaskId,  row.vendorInvoiceId, urlParts.type, 'user')
      },
      handleClickMainTabs(tab, event) {
        this.filterBy = null
        this.filterValue = null
        this.coa = null
        this.taxCode = null
        this.period = []
        const routeObject = {
          path: '/journal-and-gl',
          query: {
            companyId: this.$route.query.companyId,
            tab: tab.name
          }
        }
        const resolved = this.$router.resolve(routeObject)
        if (this.$route.fullPath !== resolved.href) {
          this.$router.push(routeObject)
        }
        if(tab.name === 'general'){
          this.$refs['general'].openModal()
          this.transactionCode = 'GENERAL'
        } else if (tab.name === 'purchase') {
          this.$refs['purchase'].openModal()
          this.transactionCode = 'PURCHASE'
        } else if (tab.name === 'sales') {
          this.$refs['sales'].openModal()
          this.transactionCode = 'SALES'
        } else if (this.activeTab === 'cashReceipts') {
          this.$refs['cashReceipts'].openModal()
          this.transactionCode = 'CASHRECEIPT'
        } else if (this.activeTab === 'cashDisbursements') {
          this.$refs['cashDisbursements'].openModal()
          this.transactionCode = 'CASHDISBURSEMENT'
        } else if (this.activeTab === 'purchaseReturns') {
          this.$refs['purchaseReturns'].openModal()
          this.transactionCode = 'PURCHASERETURN'
        } else if (this.activeTab === 'salesReturns') {
          this.$refs['salesReturns'].openModal()
          this.transactionCode = 'SALESRETURN'
        } else if (this.activeTab === 'journalReport') {
          this.$refs['journalReport'].openModal()
        } else if (this.activeTab === 'deleted') {
          this.$refs['deleted'].openModal()
        } else if (this.activeTab === 'voidEntries') {
          this.$refs['void'].openModal()
        } else if (this.activeTab === 'templates') {
          this.$refs['templates'].openModal()
        }
      },
      handleClickTabs(tab, event){
        switch (tab.name){
          case 'addedExpensesMyList':
            this.setValueProjectAfterSubmit(this.projectId);
            break;
          case 'addedExpensesProjectList':
            this.setValueProjectAfterSubmit(this.projectId);
            break;
          case 'requestExpensesMyList':
            alert('requestExpensesMyList');
            break;
          case 'requestExpensesProjectList':
            alert('requestExpensesProjectList');
            break
        }
      },
      handleSubmit(index, row, state) {

        const urlParts = this.buildUrl(state, row);
        console.log('urlParts', urlParts);

        axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
        axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
        axios
          .post(`/api/v1/${urlParts.myState}/submit?companyId=${this.$route.query.companyId}&${urlParts.stateProjectId}=${urlParts.projectId}&${urlParts.stateTaskId}=${urlParts.taskId}&${urlParts.stateExpenseId}=${row.id}`)
          .then(response => {
            this.notification("Success", "Submit Expense", "success")
            this.setValueProjectAfterSubmit(this.projectId, this.activeState)
          })
          .catch(error => {
            console.log('An error occurred:', error);
          });
        console.log(index, row)
      },
      handleDelete(index, row, state){
        console.log('rowId', row)
        const urlParts = this.buildUrl(state, row)
        console.log('urlParts', urlParts)
        this.selectedRowId = row.vendorInvoiceId

        this.$confirm('This will permanently delete the Request Vendor Invoice. Continue?', 'Warning', {
          confirmButtonText: 'OK',
          cancelButtonText: 'Cancel',
          type: 'info'
        }).then(() => {
          this.$message({
            type: 'success',
            message: 'Delete completed'
          });

          let loader = this.$loading.show();
          axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
          axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
          axios
            .get(`/api/v1/${urlParts.myState}/delete?id=${row.vendorInvoiceId}`)
            .then(response => {
              this.setValueProjectAfterSubmit(this.projectId, state);
              loader.hide()
            })
            .catch(error => {
              console.log('An error occurred:', error);
              loader.hide()
            });
        }).catch(() => {
          this.$message({
            type: 'info',
            message: 'Delete canceled'
          });
        });
      },
      handleOrder(index, row, state){
        console.log('index', index)
        console.log('row', row)
        console.log('state', state)
        this.$confirm('Create Purchase Order from Purchase Request. Continue?', 'Warning', {
          confirmButtonText: 'OK',
          cancelButtonText: 'Cancel',
          type: 'info'
        }).then(() => {
          let loader = this.$loading.show();
          let type = ''
          if(row.projectTaskId){
            type = 'projectTask'
          }else if(row.projectId){
            type = 'project'
          }else if(row.engagementTaskId){
            type = 'engagementTask'
          }else if(row.engagementId){
            type = 'engagement'
          }else if(row.businessUnitTaskId){
            type = 'businessUnitTask'
          }else if(row.businessUnitId){
            type = 'businessUnit'
          }
          axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
          axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
          axios
            .post(`/api/v1/purchaseOrder/createFromRequest?type=${type}&id=${row.purchaseRequestId}`)
            .then(response => {
              this.setValueProjectAfterSubmit(this.projectId, state);
              this.$message({
                type: 'success',
                message: 'Delete completed'
              });
              loader.hide()
            })
            .catch(error => {
              console.log('An error occurred:', error);
              loader.hide()
            });        }).catch(() => {
          this.$message({
            type: 'info',
            message: 'Canceled'
          });
        });
      },
      handleShowImg(index, row, state){
        const urlParts = this.buildUrl(state, row);
        console.log(index, row);
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
        axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
        axios
          .post(`/api/v1/${urlParts.myState}/fieldInfo?companyId=${this.$route.query.companyId}&${urlParts.stateProjectId}=${urlParts.projectId}&${urlParts.stateTaskId}=${urlParts.taskId}}&${urlParts.stateExpenseId}=${row.id}&field=file`)
          .then(response => {
            this.viewFile(response.data.fieldInfo.url)
          })
          .catch(error => {
            // this.$refs.confirmation.close()
            console.log('An error occurred:', error);
          });
      },
      viewFile(url) {
        let type = url.split('.').pop().toUpperCase()
        if (type == 'STEP' || type == 'STP' || type == 'IGES' || type == 'IGS' || type == 'BREP' || type == 'STL' || type == 'SAT' || type == 'X_T' || type == 'X_B' || type == 'SLDPRT' || type == 'DWG' || type == 'DXF' || type == 'DWF' || type == 'HPGL' || type == 'PLT' || type == 'CGM' || type == 'SVG' || type == 'EMF' || type == 'WMF' || type == 'JPG' || type == 'JPEG' || type == 'PNG' || type == 'BMP' || type == 'OGG' || type == 'MP4' || type == 'WMA' || type == 'MP3' || type == 'WAV' || type == 'OGG' || type == 'M4A' || type == 'PDF') {
          this.fileUrl = url
          this.type = this.fileUrl.split('.').pop().toUpperCase()
          console.log('---', this.fileUrl, this.type);

          if (this.type == 'JPG' || this.type == 'JPEG' || this.type == 'PNG' || this.type == 'BMP') {
            this.viewerType = 2;
            setTimeout(() => {
              console.log('-----', this.$el);
              const viewer = this.$el.querySelector('.images').$viewer
              viewer.show()
            }, 300);
          } else if (this.type == 'OGG' || this.type == 'MP4') {
            this.viewerType = 3;
            setTimeout(() => {
              // this.$refs.video.open();
            }, 300);
          } else if (this.type == 'WMA' || this.type == 'MP3' || this.type == 'WAV' || this.type == 'OGG' || this.type == 'M4A') {
            this.viewerType = 4;
            setTimeout(() => {
              // this.$refs.video.open();
            }, 300);
          } else if (this.type == 'PDF') {
            this.viewerType = 1;
            this.fileUrl = process.env.VUE_APP_TF_PDF_VIEWER_BASE_URL + '/?file=' + this.fileUrl
            setTimeout(() => {
              // this.$refs.nestedChild.open();
              window.open(this.fileUrl);
            }, 300);
          } else if (this.type == 'STEP' || this.type == 'STP' || this.type == 'IGES' || this.type == 'IGS' || this.type == 'BREP' || this.type == 'STL' || this.type == 'SAT' || this.type == 'X_T' || this.type == 'X_B' || this.type == 'SLDPRT' || this.type == 'DWG' || this.type == 'DXF' || this.type == 'DWF' || this.type == 'HPGL' || this.type == 'PLT' || this.type == 'CGM' || this.type == 'SVG' || this.type == 'EMF' || this.type == 'WMF') {
            // this.viewerType = 1;
            this.fileUrl = 'https://sharecad.org/cadframe/load?url=' + this.fileUrl
            setTimeout(() => {
              // this.$refs.nestedChild.open();
              window.open(this.fileUrl);
            }, 300);
          }
        }
      },
      cellClassName({row, column, rowIndex, columnIndex}){
        // console.log("COLUMN", columnIndex)
        // if(columnIndex === 0 || columnIndex === 5){
        //   return 'align-center'
        // }
      },
      headerCellClassName({row, column, rowIndex, columnIndex}){
        // if(columnIndex === 0 || columnIndex === 5){
        //   return 'align-center'
        // }
      },
      closeMod() {
        this.viewerType = 0;
      },
      cellClickVendorInvoice(row, column, event){
        console.log('row', row);
        // if(column.label !== 'File' && column.label !== 'Operations'){
        //   const urlParts = this.buildUrl(this.activeState, row);
        //   this.$refs.journalEntryInfoModal.openModalInfo(row.companyId, row.projectId || row.engagementId || row.businessUnitId, row.projectTaskId || row.engagementTaskId || row.businessUnitTaskId,  row.vendorInvoiceId, urlParts.type, 'user');
        // }
      },
      cellClickJournalEntry(row, column, event){
        console.log('row', row);
        this.$refs.journalEntryInfoModal.openModalInfo(row)
        // if(column.label !== 'File' && column.label !== 'Operations'){
        //   const urlParts = this.buildUrl(this.activeState, row);
        //   this.$refs.vendorRequestInvoiceInfoModal.openModalInfo(row.companyId, row.projectId || row.engagementId || row.businessUnitId, row.projectTaskId || row.engagementTaskId || row.businessUnitTaskId,  row.vendorInvoiceId, urlParts.type, 'user');
        // }
      },
      openModalCreateJournalEntry(state){
        const urlParts = this.buildUrl(state);
        console.log('urlParts', urlParts);
        // this.$refs['createJournalEntryModal'].openModalFromJournalCreate(urlParts.type)
        this.$refs['createJournalEntryModal'].openModalFromJournalCreate({})
      },
      openModal(state) {
        const urlParts = this.buildUrl(state);
        this.$refs['createVendorInvoiceModal'].openModalFromVendorInvoice(urlParts.type)
      },
      notification(title, message, type) {
        this.$notify({
          title: title,
          message: message,
          type: type
        });
      },
      buildUrl(state, row, activeTab) {
        console.log('state',  state, 'row', row)
        let myState = '';
        let stateProjectId = '';
        let stateTaskId = '';
        let projectId = '';
        let taskId = '';
        let type ='';
        switch(this.activeTab){
          case 'journalEntry':
            if (state === 'projectTaskVendorInvoice') {
              myState = 'journalEntry';
              stateProjectId = 'projectId';
              stateTaskId = 'projectTaskId';
              type = 'project';
              if(row){
                projectId = row.projectId;
                taskId = row.projectTaskId;
                // type = !taskId ? 'project' : 'projectTask'
                type = 'project'
              }
            } else if (state === 'engagementTaskVendorInvoice') {
              myState = 'journalEntry';
              stateProjectId = 'engagementId';
              stateTaskId = 'engagementTaskId';
              type = 'engagement';
              if(row){
                projectId = row.engagementId;
                taskId = row.engagementTaskId;
              }
            } else if (state === 'businessUnitTaskVendorInvoice') {
              myState = 'journalEntry';
              stateProjectId = 'businessUnitId';
              stateTaskId = 'businessUnitTaskId';
              type = 'business-unit';
              if(row){
                projectId = row.businessUnitId
                taskId = row.businessUnitTaskId
              }
            }
            break;
          case 'vendorInvoice':
            if (state === 'projectTaskVendorInvoice') {
              myState = 'vendorInvoice';
              stateProjectId = 'projectId';
              stateTaskId = 'projectTaskId';
              type = 'project';
              if(row){
                projectId = row.projectId;
                taskId = row.projectTaskId;
                // type = !taskId ? 'project' : 'projectTask'
                type = 'project'
              }
            } else if (state === 'engagementTaskVendorInvoice') {
              myState = 'vendorInvoice';
              stateProjectId = 'engagementId';
              stateTaskId = 'engagementTaskId';
              type = 'engagement';
              if(row){
                projectId = row.engagementId;
                taskId = row.engagementTaskId;
              }
            } else if (state === 'businessUnitTaskVendorInvoice') {
              myState = 'vendorInvoice';
              stateProjectId = 'businessUnitId';
              stateTaskId = 'businessUnitTaskId';
              type = 'business-unit';
              if(row){
                projectId = row.businessUnitId;
                taskId = row.businessUnitTaskId
              }
            }
            break
        }
        return {
          myState: myState,
          stateProjectId: stateProjectId,
          stateTaskId: stateTaskId,
          projectId: projectId,
          taskId: taskId,
          type: type
        }
      }
    },
    watch:{
      // purchaseListRequest(val){
      //   val.forEach(i =>{
      //     if(i.purchaseRequest.orderDate) {
      //       i.purchaseRequest.orderDate = moment(i.purchaseRequest.orderDate.toString(), 'X').format('DD MMM YYYY')
      //     }
      //   })
      // },
      vendorInvoiceList(val){
        val.forEach(i =>{
          if(i.vendorInvoice.date){
            i.vendorInvoice.date = moment(i.vendorInvoice.date.toString(), 'x').format('DD MMM YYYY')
          }
          if(i.vendorInvoice.dueDate){
            i.vendorInvoice.dueDate = moment(i.vendorInvoice.dueDate.toString(), 'x').format('DD MMM YYYY')
          }
        })
      },
      coa(val) {
        if (!val) this.$refs[this.activeTab].item(null, null)
      },
      taxCode(val) {
        if (!val) this.$refs[this.activeTab].item(null, null)
      },
    }
  }
</script>

<style lang="scss" scoped>
    .expenses{
        background: #fff;
    }

    .content {
        display: flex;
        min-height: 100vh;
        padding-top: 50px;
    }

    // [ Wrapper ] start
    .wrap {
        display: flex;
        justify-content:center;
        width: 100%;
        padding: 20px 10px 10px 10px;

        &__tree {
            max-width: 1500px;
            width:100%;
            padding: 0 0 10px 0;
        }
        &.animation{
            margin-left:260px;
            transition: margin-left 500ms ease-out, transform 500ms ease-out;
        }
    }
    // [ Wrapper ] end

    // [ Nav tree ] start
    .nav-tree {
        padding-bottom: 10px;
        &__item {
            margin: 0 0 5px 0;
            &_btn{
                /*margin-left:10px;*/
            }
        }
        .el-button {
            margin-right: 10px;
        }
        .el-radio{
            margin-right:0;
        }
        .inputs{
            margin-left:10px;
        }
    }
    // [ Nav tree ] end

    // [ Modal ] start
    .button{
        cursor: pointer;
    }
    // [ Modal ] end
    .modal__title{
        border-bottom: 1px solid #EBEEF5;
        padding-bottom: 10px;
    }
    .history-block{
        height:300px;
        overflow-y: auto;
    }
    .history-item-block{
        padding-top: 10px;
        padding-bottom: 10px;
        border-top: 1px solid #EBEEF5;
        border-bottom: 1px solid #EBEEF5;
    }
    .modal__amount{
        border-bottom: 1px solid #EBEEF5;
        padding-bottom: 10px;
    }
    .iframe{
        width:640px;
        height:700px;
    }
    .modal__bottom{
        margin-top:20px;
    }
    .modal__history_btn_block{
        margin-top:20px;
    }
    .menu{
        min-height:calc(100vh - 50px);
    }
    .menu.animation{
        position: fixed;
    }
    /deep/.el-upload{
        width:100%;
    }
    /deep/.el-upload-dragger{
        min-width:100%;
    }

    /deep/.el-range-separator{
      position:relative;
      &::before{
        color: #C0C4CC;
        font-family: "element-icons";
        position:absolute;
        content: "\E78E";
        left:5px;
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
      }
    }
.importClients {
  width: 100%;
  &__label {
    width: 100%;
    color: #409EFF;
    padding: 7px 15px;;
    border: 1px solid #b3d8ff;
    border-radius: 3px;
    cursor: pointer;
    &:hover {
      background: #409EFF;
      border-color: #409EFF;
      color: #FFF;
    }
  }
}
</style>
